"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _elliptic = require("elliptic");

var _Digest = require("./Digest");

var secp256k1 = new _elliptic.ec('secp256k1');

function leftpad(data) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 64;
  if (data.length === size) return data;
  return '0'.repeat(size - data.length) + data;
}
/**
*  The SimpleSigner returns a configured function for signing data. It also defines
*  an interface that you can also implement yourself and use in our other modules.
*
*  @example
*  const signer = SimpleSigner(process.env.PRIVATE_KEY)
*  signer(data, (err, signature) => {
*    ...
*  })
*
*  @param    {String}         hexPrivateKey    a hex encoded private key
*  @return   {Function}                     a configured signer function
*/


function SimpleSigner(hexPrivateKey) {
  var privateKey = secp256k1.keyFromPrivate(hexPrivateKey);
  return (
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(data) {
        var _privateKey$sign, r, s, recoveryParam;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _privateKey$sign = privateKey.sign((0, _Digest.sha256)(data)), r = _privateKey$sign.r, s = _privateKey$sign.s, recoveryParam = _privateKey$sign.recoveryParam;
                return _context.abrupt("return", {
                  r: leftpad(r.toString('hex')),
                  s: leftpad(s.toString('hex')),
                  recoveryParam: recoveryParam
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

module.exports = SimpleSigner;